module.exports = __webpack_public_path__ + "resources/img/logo_partner_game_10.9720b1dd76f368da6b6cd7b3ede548db.png";